<template>
  <div class="home">
    <div class="banner">
      <div class="swiper-container bot">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide slide"
            v-for="(item, index) in index_news"
            :key="index"
            @click="tolink(item.url)"
          >
            <img :src="item.photo && $imgurl + item.photo.url" alt="" />
            <div class="sam_box">
              <div class="txt">{{ item.title }}</div>
              <div class="img_r" @click.stop="tolink(item.url)">
                <img src="../assets/imgapp/home_r.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div class="box2">
      <div class="txt">
        业务领域
        <div class="img">
          <img src="../assets/imgapp/business@2x.png" alt="" />
        </div>
      </div>
    </div>

    <div class="box3">
      <my-amit :ind="selected"></my-amit>

      <div class="text" v-if="index_trade[0]">
        <div class="txt" @click='tobusi'>{{ index_trade[selected].title }}</div>
        <div v-html="index_trade[selected].content" @click="tobusi"></div>

        <div class="imglogo">
          <img
            :src="
              index_trade[selected].exp1 &&
              $imgurl + index_trade[selected].exp1.url
            "
            alt=""
          />
        </div>
      </div>

      <div class="tabs" v-if="index_trade[0]">
        <div
          class="tablist cursor"
          :class="[{ hover: selected == index }]"
          v-for="(item, index) in index_trade2"
          :key="index"
          @click="selected = index"
          @mousemove="secuind = index"
          @mouseout="secuind = -1"
        >
          <img
            :src="
              selected == index
                ? item.exp3 && $imgurl + item.exp3.url
                : item.exp2 && $imgurl + item.exp2.url
            "
            alt=""
          />
          <div class="txt">{{ item.title }}</div>
        </div>

        <!-- <div class="txt_w">
          <div class="txt_a" @click="toPath(index_trade[selected].id)">
            MORE .
          </div>
        </div> -->
      </div>
    </div>

    <div class="box4">
      <div class="txt">
        行业解决方案
        <div class="logo">
          <img src="../assets/imgapp/solution@2x.png" alt="" />
        </div>
      </div>

      <div class="tabs">
        <ul>
          <li
            @click="chan(index)"
            v-for="(item, index) in index_solution2"
            :key="index"
          >
            <div>
              <div class="top">
                <img :src="
                curindex==index&&flg?
                item.exp2&& $imgurl + item.exp2.url:
                item.photo && $imgurl + item.photo.url
                " 
                alt="" />
                 <img class="img_01" src="../assets/imgapp/dian.png" alt=""
                 v-show="curindex == index && flg"
                 >
                <div class="text">{{ item.title }}</div>
              </div>
              <div class="bottom">
                <img
                  :class="curindex == index&&flg ? 'img_s' : ''"
                  src="../assets/imgapp/home_i.png"
                  alt=""
                />
              </div>
            </div>

            <div
              class="box_b"
              :class="curindex==index&&flg? 'active' : ''"
              :style="{
                background: `url(${
                  $imgurl + item.exp1.url
                })0 0/cover no-repeat`,
              }"
            >
              <div class="box_b_in">
                <div
                  class="txtx"
                  v-for="(item2, index2) in item.second"
                  :key="index2"
                >
                  <p v-html="item2.title" @click='toindu(index,item2.id,item.id)'></p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="box5" @click="toclik">
      <div class="txt">成为全球领先的金融科技公司</div>
      <div class="btn">了解更多</div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import myAmit from "@/components/amit";
export default {
  components: {
    myAmit,
  },
  data() {
    return {
      //业务领域
      index_trade: [],
      index_trade2: [],
      selected: 0,
      flg: false,
      //轮播
      index_news: [],
      //行业解决方案
      index_solution: [],
      index_solution2: [],
      curindex:0,
      mySwiper:null
    };
  },
  methods: {
    //数据请求
    getdata() {
      this.$fetch({
        url: "index.php/welcome/index",
        type: "get",
      }).then((res) => {
        this.index_news = res.data.index_news;
        this.index_cptd = res.data.index_cptd;
        this.index_hd = res.data.index_hd;
        this.index_hssj = res.data.index_hssj;
        this.index_trade = res.data.index_trade;
        this.index_solution = res.data.index_solution;
        this.createArray();
        this.createArray2();
        console.log(this.index_trade2);
        this.$nextTick(() => {
          this.getswiper();
        });
      });
    },
    //轮播
    getswiper() {
    this.mySwiper = new Swiper(".swiper-container", {
        loop: true,
        // 如果需要分页器
        pagination: ".swiper-pagination",
        // 如果需要前进后退按钮
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        //如果需要自动切换海报
        // autoplay: {
        //   delay: 1000,//时间 毫秒
        //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
        // }
         autoplay : 3000,
      });

    },
    createArray(){
      this.index_trade.forEach(item=>{  
        if(item.title != "行业咨询"){
          this.index_trade2.push(item);  
        }
      })
      
    },
    createArray2(){
      this.index_solution.forEach(item=>{  
        if(item.title != "行业解决方案"){
          this.index_solution2.push(item);  
        }
      })
    },
    //li点击展开
    chan(index) {
      console.log(index);
      if(this.curindex == index){
        this.flg = !this.flg
        return;
      }
      this.flg = true;
      this.curindex = index;
    },
    //swiper点击跳外链
    tolink(url) {
      window.open(url, "_block");
    },
    //点击跳关于我们
    toclik() {
      this.$router.push({ path: "/about" });
    },
    //跳页面指点位置
    toindu(index,id,crid){
      this.$router.push({path:"/industry",query:{index,id,crid}})
    },
    //跳业务领域
    tobusi(){
      this.$router.push({path:"/business"})
    }
    

   // $(".box4 .cont .left_list").each(function(){
//   if($(this).find(".bar").html() == "信托"){
//     $(this).stop().hide();
//   }
// }) 
  },
  mounted() {
    this.getdata();
  },
};


</script>

<style>
.home .banner .swiper-pagination-bullet {
  width: 43px;
  height: 6px;
  background: #ffffff;
  opacity: 0.3;
  border-radius: 0;
}
.home .banner .swiper-pagination-bullet-active {
  background: #ffffff;
  width: 43px;
  height: 6px;
  opacity: 1;
}
.home .banner .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 131px;
}
</style>
<style scoped>
.banner {
  width: 750px;
  height: 760px;
}
.banner .bot {
  width: 100%;
  height: 100%;
}
.banner .slide {
  position: relative;
}
.banner .swiper-slide img {
  width: 100%;
  height: 100%;
}
.banner .swiper-slide .sam_box {
  width: 100%;
  height: 115px;
  background: linear-gradient(
    327deg,
    rgba(57, 106, 255, 0.33) 0%,
    #396aff 100%
  );
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 30px;
}
.banner .sam_box .txt {
  width: 627px;
  height: 24px;
  font-size: 28px;
  color: #ffffff;
  line-height: 24px;
  margin-right: 30px;
}
.banner .sam_box .img_r img {
  width: 34px;
  height: 34px;
}

.box2 {
  height: 239px;
  display: flex;
  align-items: center;
}
.box2 .txt {
  /* width: 160px; */
  height: 50px;
  font-size: 36px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  margin: 0 auto;
  position: relative;
}
.box2 .img {
  position: absolute;
  top: -40px;
  left: calc(50% - 153.5px);
  z-index: -1;
}
.box2 .img img {
  width: 301px;
  height: 47px;
}

.box3 {
  width: 100%;
  height: 1009px;
  background-image: url(../assets/imgapp/bg31.png);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  background-size: cover;
}
.box3 .imglogo img {
  position: absolute;
  top: -300px;
  right: -380px;
  max-width: 200px;
  min-height: 85px;
}
.box3 .text {
  width: 324px;
  color: #fff;
  position: absolute;
  top: 340px;
  left: 30px;
}
.box3 .text > div {
  width: 512px;
  height: 110px;
  font-size: 28px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.box3 .text .txt {
  width: fit-content;
  height: 50px;
  font-size: 36px;
  font-weight: 600;
  color: #ffffff;
  line-height: 50px;
  margin-bottom: 20px;
}
.box3 .tabs .txt_w {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: -86px;
  left: 0px;
}

.box3 .tabs .txt_a {
  height: 33px;
  font-size: 24px;
  color: #06d3da;
}
.box3 .tabs {
  width: 690px;
  margin: 0 auto 60px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  z-index: 3;
}
.box3 .tablist {
  width: 230px;
  height: 156px;
  border: 1px solid #8c99f3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  position: relative;
}
.box3 .tablist::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/img01/b3-tabs.png");
  opacity: 0;
  transition: all 0.5s linear;
  z-index: -1;
  background-size: cover;
}
.box3 .tablist:hover::after {
  opacity: 1;
}
.box3 .tablist:hover .txt {
  color: #4d3ddf;
  font-weight: 600;
}
.box3 .tablist.hover {
  background: url("../assets/img01/b3-tabs.png");
  background-size: cover;
}
.box3 .tablist.hover .txt {
  color: #4d3ddf;
  font-weight: 600;
}
.box3 .tablist img {
  width: 48px;
  height: 48px;
}
.box3 .tablist .txt {
  margin-top: 12px;
  font-size: 28px;
}
.box4 {
  background: linear-gradient(9deg, #e3e6ed 0%, #ffffff 100%);
}
.box4 .txt {
  /* width: 240px; */
  height: 50px;
  font-size: 36px;
  font-weight: 400;
  text-align: center;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  margin: 0 auto 0;
  padding-top: 110px;
  position: relative;
}
.box4 .txt .logo {
  position: absolute;
  top: 70px;
  left: calc(50% - 155px);
}
.box4 .txt .logo img {
  width: 305px;
  height: 47px;
}
.box4 .tabs {
  padding: 0 30px;
}
.box4 ul li > div:nth-child(1) {
  height: 118px;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.box4 ul li:nth-child(1) {
  margin-top: 20px;
}
.box4 ul li .box_b {
  height: 0;
  overflow: hidden;
  transition: height 0.3s linear;
  background-image: url(../assets/imgapp/home_bg2.png);
  background-size: cover;
  width: 100%;
}
.box4 ul li .active {
  height: 670px;
}
.box4 ul li .box_b_in {
  height: 670px;
  margin-top: 50px;
}
.box4 ul li .box_b_in .txtx {
  padding: 10px 0 0 30px;
}
.box4 .box_b_in .txtx p {
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  line-height: 42px;
  text-shadow: 10px 10px 24px rgba(255, 255, 255, 0.6);
}
.box4 .tabs .top {
  display: flex;
  align-items: center;
  position:relative
}
.box4 .tabs .top img:nth-of-type(1) {
 max-width:57px;
 max-height:67px;
  margin-right: 30px;
}
.box4 .tabs .top .img_01{
  position:absolute;
  top: -20px;
  left:-20px;
  width:101px;
  height:63px;
}
.box4 .tabs .top .text {
  font-size: 28px;
  color: #333333;
  line-height: 37px;
}
.box4 .tabs .bottom img {
  width: 32px;
  height: 32px;
  transition: all 0.3s linear;
}
.box4 .tabs .bottom .img_s {
  transform: rotate(-180deg);
  transition: all 0.3s linear;
}
.box5 {
  width: 100%;
  height: 200px;
  background: url(../assets/imgapp/home_bg3.png);
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.box5 .txt {
  margin-bottom: 24px;
  /* width: 403px; */
  height: 37px;
  font-size: 28px;
  color: #ffffff;
  line-height: 37px;
  letter-spacing: 3px;
}
.box5 .btn {
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 19px 56px;
}
</style>